import React, { useRef, useState } from 'react';
import { Box, ClickAwayListener, MenuList, MenuItem, Popper, Paper, styled, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export interface AdminDropdownProps {
  checkDevFlag: boolean;
  changeNavigation: (path: string) => void;
}

export const AdminDropdown = ({ checkDevFlag, changeNavigation }: AdminDropdownProps) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const handleClose = () => setOpen(false);
  const handleToggle = () => setOpen((prevOpen) => !prevOpen);
  const StyledMenuItem = styled(MenuItem)({
    margin: '0',
    textTransform: 'none',
  });

  return (
    <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative', float: 'right' }}>
      <Button
        onClick={handleToggle}
        color="inherit"
        ref={anchorRef}
        sx={{
          backgroundColor: window.location.pathname.startsWith(`/app/admin`) ? 'white' : '#1D2026',
          color: window.location.pathname.startsWith(`/app/admin`) ? '#1D2026' : 'white',
          textTransform: 'none',
          letterSpacing: '.5px',
          '&:hover': {
            background: '#6C696A',
            color: 'white',
          },
        }}
        aria-label={`${open ? 'Close' : 'Open'} admin menu`}
        aria-haspopup="true"
        aria-controls={open ? 'menu-list-dropdown' : undefined}
        size="large"
        data-cy="admin-ddown"
      >
        Administration
        {open ? (
          <ExpandLessIcon
            sx={{
              letterSpacing: '.5px',
              '&:hover': {
                background: '#6C696A',
                color: 'white',
              },
            }}
            fontSize="small"
          />
        ) : (
          <ExpandMoreIcon
            sx={{
              letterSpacing: '.5px',
              '&:hover': {
                background: '#6C696A',
                color: 'white',
              },
            }}
            fontSize="small"
          />
        )}
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        disablePortal={true}
        placement="bottom-end"
        style={{ zIndex: 15, width: '250px' }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper>
            <MenuList id="menu-list-dropdown" style={{ padding: '0' }}>
              <StyledMenuItem
                onClick={() => {
                  changeNavigation(`/app/admin/api/tests`);
                  handleClose();
                }}
                data-cy="api-opt"
              >
                API
              </StyledMenuItem>
              <StyledMenuItem
                onClick={() => {
                  changeNavigation(`/app/admin/adk/suites`);
                  handleClose();
                }}
              >
                ADK
              </StyledMenuItem>
              <StyledMenuItem
                onClick={() => {
                  changeNavigation(`/app/admin/android-tv`);
                  handleClose();
                }}
              >
                Android
              </StyledMenuItem>
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};
